import * as React from "react";
import { useTranslation } from "react-i18next";
import DynamicForm from "../../../../../core/presentations/DynamicForm";
import Validators from "../../../../../ui/helpers/validators";
import LeftLabelFieldTemplate from "../../../../../ui/templates/fields/LeftLabelFieldTemplate";
import TopLabelFieldTemplate from "../../../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../../../ui/templates/objects/VerticalFormTemplate";
import PrwcBasicButton from "../../../../../ui/widgets/custom/buttons/PrwcBasicButton";

const ShiftMapping = (props: any) => {
  const { data } = props;
  const { t } = useTranslation();
  const submitButtonRef: any = React.useRef(null);
  const [formData, setFormData] = React.useState(data);

  const onChange = (formData: any) => {
    setFormData(formData);
  };

  const onSubmit = (data: any) => {
    console.log("data submitted ---");
    console.log(data);
  };

  const onError = (data: any) => {
    console.log("on error ---");
    console.log(data);
  };

  const handleOnSubmit = () => {
    // It is to submit form programmatically.
    submitButtonRef.current.click();
  };

  const formButtons = () => {
    return (
      <button ref={submitButtonRef} type="submit" className="hidden p-col-12" />
    );
  };

  const schema: any = {
    title: t("shiftDetails.label.general"),
    type: "object",
    properties: {
      firstHalfShiftCode: {
        type: "string",
        title: t("shiftDetails.label.firstHalfShiftCode"),
      },
      secondHalfShiftCode: {
        type: "string",
        title: t("shiftDetails.label.secondHalfShiftCode"),
      },
      fullDayShiftCode: {
        type: "string",
        title: t("shiftDetails.label.fullDayShiftCode"),
      },
      displayShiftTime: {
        type: "boolean",
        title: t("shiftDetails.label.displayShiftTime"),
      },
      rosterDisplayCode: {
        type: "string",
        title: t("shiftDetails.label.rosterDisplayCode"),
      },
      shiftCategory: {
        type: "string",
        title: t("shiftDetails.label.shiftCategory"),
      },
    },
    required: ["firstHalfShiftCode", "secondHalfShiftCode"],
  };

  const validationSchema: any = {
    firstHalfShiftCode: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "shiftDetails.validation.firstHalfShiftCodeRequired",
        },
      ],
    },
    secondHalfShiftCode: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "shiftDetails.validation.secondHalfShiftCodeRequired",
        },
      ],
    },
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    firstHalfShiftCode: {
      "ui:widget": "prwDropdownBasic",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    secondHalfShiftCode: {
      "ui:widget": "prwDropdownBasic",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    fullDayShiftCode: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    displayShiftTime: {
      "ui:widget": "prwToggleButton",
      "ui:FieldTemplate": LeftLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    rosterDisplayCode: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    shiftCategory: {
      "ui:widget": "prwDropdownBasic",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
  };

  return (
    <div className="group">
      <div className="px-4 overflow-y-auto content-height">
        <DynamicForm
          onChange={onChange}
          formData={formData}
          onSubmit={onSubmit}
          onError={onError}
          schema={schema}
          uiSchema={uiSchema}
          validationSchema={validationSchema}
          formButtons={() => formButtons()}
        ></DynamicForm>
      </div>
      <div className="flex justify-end px-2 border-t">
        <PrwcBasicButton
          onClick={handleOnSubmit}
          labelKey="users.action.save"
          className="w-24 h-8 my-1 bg-blue-700 border-blue-700 p-button-sm"
        ></PrwcBasicButton>
      </div>
    </div>
  );
};

export default ShiftMapping;
